import { HTTP2PushClient } from "@infrastructure/clients/http2-push/clients/base/http2Push.client";
import { BASE_URL } from "@infrastructure/clients/http/config";
import type { HTTP2PushOptions } from "@infrastructure/clients/http2-push/clients/base/http2Push.client";

export class ResourcesHTTP2PushClient extends HTTP2PushClient {
  baseUrl = BASE_URL;

  constructor() {
    super();
  }

  async subscribeToResource(resourcePath: string, options: HTTP2PushOptions): Promise<() => void> {
    return this.subscribeToPush(resourcePath, options);
  }
}

